// removed by extract-text-webpack-plugin
module.exports = {"NavigationItem":"NavigationItem__NavigationItem__-hash-base-64-5-","active":"NavigationItem__active__-hash-base-64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/NavigationItems/NavigationItem/NavigationItem.scss
// module id = 119
// module chunks = 0